import React, { useEffect, useState } from 'react';

const COPIED_MS = 2000;

/** Copy a live link to the clipboard, confirming for a moment. */
export const LiveSiteCopyButton: React.FC<{ url: string; className?: string }> = ({
  url, className = 'live-site-copy-btn',
}) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const timer = setTimeout(() => setCopied(false), COPIED_MS);

    return () => clearTimeout(timer);
  }, [copied]);

  const copy = () => {
    void navigator.clipboard?.writeText(url).then(() => setCopied(true)).catch(() => setCopied(false));
  };

  return (
    <button type="button" className={className} onClick={copy} aria-label={`Copy the live link ${url}`}>
      {copied
        ? <><i className="fa-solid fa-check" aria-hidden="true" /> Copied</>
        : <><i className="fa-regular fa-copy" aria-hidden="true" /> Copy</>}
    </button>
  );
};
